package com.qrkontaq.pages.admin

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.admin.PlatformAdminScreen
import com.varabyte.kobweb.core.Page

/**
 * Fallback path for the platform owner's dashboard; the primary home is the
 * adminkontaq.qrkontaq.com subdomain root.
 */
@Page("/admin/platform")
@Composable
fun AdminPlatformPage() {
    PlatformAdminScreen()
}
